import React, { Component } from "react";
import RichTextEditor from "react-rte";

export default class MyStatefulEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: RichTextEditor.createValueFromString(props.markup || "", "html"),
    };
  }

  toolbarConfig = {
    display: [
      "HISTORY_BUTTONS",
      "BLOCK_TYPE_DROPDOWN",
      "BLOCK_ALIGNMENT_BUTTONS",
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "LINK_BUTTONS",
      "IMAGE_BUTTON",
      "HORIZONTAL_RULE_BUTTON",
    ],
    HISTORY_BUTTONS: [
      { label: "Undo", style: "undo" },
      { label: "Redo", style: "redo" },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: "Normal", style: "unstyled" },
      { label: "Heading Large", style: "header-one" },
      { label: "Heading Medium", style: "header-two" },
      { label: "Heading Small", style: "header-three" },
    ],
    BLOCK_ALIGNMENT_BUTTONS: [
      { label: "Left", style: "ALIGN_LEFT" },
      { label: "Center", style: "ALIGN_CENTER" },
      { label: "Right", style: "ALIGN_RIGHT" },
      { label: "Justify", style: "ALIGN_JUSTIFY" },
    ],
    INLINE_STYLE_BUTTONS: [
      { label: "Italic", style: "ITALIC" },
      { label: "Bold", style: "BOLD" },
      { label: "Underline", style: "UNDERLINE" },
      { label: "Strikethrough", style: "STRIKETHROUGH" },
      { label: "<>", style: "CODE" },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: "UL", style: "unordered-list-item" },
      { label: "OL", style: "ordered-list-item" },
      { label: "“”", style: "blockquote" },
    ],
    LINK_BUTTONS: [{ label: "Link", style: "link" }],
    IMAGE_BUTTON: [{ label: "Image", style: "image" }],
    HORIZONTAL_RULE_BUTTON: [{ label: "—", style: "horizontal-rule" }],
  };

  onChange = (value) => {
    const plainText = value.getEditorState().getCurrentContent().getPlainText();
    const charCount = plainText.length;
    const maxChars = 2000;

    // ✅ Always update the internal editor value to allow backspace/undo
    this.setState({ value });
    this.props.setDescription(plainText);

    // ✅ Only propagate to parent if within character limit
    if (charCount <= maxChars) {
      this.props.isLimitExceeded(false);
      if (this.props.onChange) {
        this.props.onChange(value.toString("html"));
      }
    } else {
      this.props.isLimitExceeded(true);
    }
  };

  render() {
    return (
      <RichTextEditor
        value={this.state.value}
        onChange={this.onChange}
        toolbarConfig={this.toolbarConfig}
      />
    );
  }
}
